enum MemberGroups {
  defaultUser = "defaultUser",
  castingDirector = "castingDirector",
  castingDirectorIpc = "castingDirector:ipc",
  castingBBC = "castingDirectorBBC",
  performer = "performer",
  agent = "agent",
  yPerformer = "performer:youngPerformer",
  graduatePerformer = "performer:graduate",
  anonymous = "anonymous",
}

export default MemberGroups;
